module.exports = __webpack_public_path__ + "static/lighthouse-1.7fc115f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/lighthouse-1.jpg
// module id = 150
// module chunks = 35783957827783 249938909357035